module.exports = __webpack_public_path__ + "static/media/searchGrey.cabd25d7.svg";